import { Icon } from '@iconify/react'
import classNames from 'classnames'
import { useAppSelector } from 'common/hooks/redux'
import { useSceneActions } from 'features/Procedure/hooks/useSceneActions'
import styles from './model-scene-toggle-button.module.scss'

type Props = {
  className?: string
}

export const ModelSceneToggleButton = ({ className }: Props) => {
  const isModelSceneExpanded = useAppSelector(
    (state) => state.procedureReducer.isModelSceneExpanded,
  )
  const { handleToggleModelSceneExpanded } = useSceneActions()

  return (
    <button
      className={classNames(styles.toggleButton, className, {
        [styles.isActive]: !isModelSceneExpanded,
      })}
      onClick={handleToggleModelSceneExpanded}
      title={isModelSceneExpanded ? 'Collapse model' : 'Expand model'}>
      <Icon icon={isModelSceneExpanded ? 'mdi:arrow-collapse-left' : 'mdi:account'} fontSize={16} />
    </button>
  )
}
